/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_ACCESS,
  LOAD_DASHBOARD_TRANSACTIONS,
  LOAD_MENU_LIST,
  LOAD_USER_PERMISSON_LIST,
  LOAD_USER_ROLE_LIST,
  LOAD_INFO_LIST,
  LOAD_USER_ACCESS,
  LOAD_USER_MENU
} from "./constants";

import {
  loadAccessList,
  loadAccessListSuccess,
  loadAccessListError,
  loadMenuList,
  loadMenuListSuccess,
  loadMenuListError,
  loadUserRoleList,
  loadUserRoleListSuccess,
  loadUserRoleListError,
  loadDashboardTransactions,
  loadDashboardTransactionsSuccess,
  loadDashboardTransactionsError,
  loadUserPermissionList,
  loadUserPermissionListSuccess,
  loadUserPermissionListError,
  loadInfoList,
  loadInfoListSuccess,
  loadInfoListError,
  loadUserAccessList,
  loadUserAccessListSuccess,
  loadUserAccessListError,
  loadUserMenuAccessList,
  loadUserMenuAccessListSuccess,
  loadUserMenuAccessListError
} from "./actions";

import {
  loadAccessDetails,
  loadDashboardTransactionDetails,
  loadMenuDetails,
  loadUserPermissionDetails,
  loadUserRoleDetails,
  loadInfoListDetails,
  loadUserAccessListDetails,
  loadMenuAccessListDetails
} from "./remotes";

function* loadAccessSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ACCESS),
    });

    const { explicitLoad } = load;
    const { partiesList } = explicitLoad || {};
    yield put(loadAccessList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadAccessDetails, partiesList);
        if (result) {
          yield put(loadAccessListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadAccessListError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadDashboardTransactionsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_DASHBOARD_TRANSACTIONS),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadDashboardTransactions(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadDashboardTransactionDetails,
          transactionsList
        );
        if (result) {
          yield put(loadDashboardTransactionsSuccess(result));
        }
      } catch (error) {
        yield put(
          loadDashboardTransactionsError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadMenuListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_MENU_LIST),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadMenuList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadMenuDetails, transactionsList);
        if (result) {
          yield put(loadMenuListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadMenuListError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadUserRoleDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_USER_ROLE_LIST),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadUserRoleList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadUserRoleDetails, transactionsList);
        if (result) {
          yield put(loadUserRoleListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadUserRoleListError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadUserPermissionDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_USER_PERMISSON_LIST),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadUserPermissionList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadUserPermissionDetails, transactionsList);
        if (result) {
          yield put(loadUserPermissionListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadUserPermissionListError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadInfoListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_INFO_LIST),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadInfoList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadInfoListDetails, transactionsList);
        // console.log("Result",result)
        if (result) {
          yield put(loadInfoListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadInfoListError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        );
      }
    }
  }
}


function* loadUserAccessDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_USER_ACCESS),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadUserAccessList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadUserAccessListDetails, transactionsList);
        console.log("userAccess", result)
        if (result) {
          yield put(loadUserAccessListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadUserAccessListError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadMenuAccessDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_USER_MENU),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadUserMenuAccessList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadMenuAccessListDetails, transactionsList);
        console.log("userMenuAccessSaga", result)
        if (result) {
          yield put(loadUserMenuAccessListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadUserMenuAccessListError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        );
      }
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadAccessSaga(),
    loadMenuListSaga(),
    loadDashboardTransactionsSaga(),
    loadUserRoleDetailsSaga(),
    loadUserPermissionDetailsSaga(),
    loadInfoListSaga(),
    loadUserAccessDetailsSaga(),
    loadMenuAccessDetailsSaga()
  ]);
}
